import React, { Component, useState } from "react";
import PropTypes from "prop-types";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withTranslation } from "react-i18next";
import { isEmpty, map } from "lodash"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "flatpickr/dist/themes/material_blue.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import DeleteModal from "../../../components/Common/DeleteModal";
import * as Yup from "yup";
import {
  getProjectUUIDAction,
  addProjectMedia, 
  getProjectMedia,
  addProjectLink, 
  getProjectLink,
  getProjectOpenHouseFiles,
  deleteProjectOpenHouseFile
} from "../../../store/projects/actions";
import ProjectSidebar from "../../../components/VerticalLayout/ProjectSidebar";
import classnames from "classnames";
import axios from "axios"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import {
  Row,
  Col,
  CardBody,
  Card,
  CardText,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  CardHeader,
  CardTitle
} from "reactstrap";
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import FileBase64 from "../../../components/Common/FileBase64";
import WebpagesMenu from "./menu/webpages-menu";
import WebPageBreadcrumbs from "components/Common/WebpageBreadcrumb";
import { BlobServiceClient } from '@azure/storage-blob';
import Swal from 'sweetalert2'
import CopyText from "components/buttons/copyBtn";
import SaveButton from "components/buttons/save";
import img1 from "../../../assets/img/doc-1.png"
import img2 from "../../../assets/img/doc-2.png"
import img3 from "../../../assets/img/doc-3.png"
import step1 from "../../../assets/img/step-1.png"
import step2 from "../../../assets/img/step-2.png"
import step3 from "../../../assets/img/step-3.png"
import arrowImg from "../../../assets/img/arrow-img.png"
class ProjectWorksheetInquiry extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      isRight: false,
      activeTab1: "1",
      fileUploaded: false,
    };
    //this.onFileChange = this.onFileChange.bind(this);
    this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
    this.toggleBackdrop = this.toggleBackdrop.bind(this);
    this.handleProjectDocumentSubmit = this.handleProjectDocumentSubmit.bind(this)
    this.handleProjectLinkSubmit = this.handleProjectLinkSubmit.bind(this)
    this.toggle1 = this.toggle1.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  onClickDelete = (opfile) => {
    this.setState({ opfile: opfile });
    this.setState({ deleteModal: true });
  };

  handleDeleteFile = () => {
    const { onDeleteFile } = this.props;
    const { opfile } = this.state;
    //
    if (opfile.id !== undefined) {
      onDeleteFile(opfile);
      this.setState({ deleteModal: false });
    }
  };
  toggle1(tab) {
    if (this.state.activeTab1 !== tab) {
      this.setState({
        activeTab1: tab,
      });
    }
  }
  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));
  }
  toggleRightCanvas() {
    this.setState({ isRight: !this.state.isRight });
    //this.toggle();
  }
  getFiles(files) {
    this.setState({ files: files });
    
  }
  handleChange = setValue => {
    this.setState({ setValue });
  };

  handleProjectDocumentSubmit(value){
    this.props.addProjectMedia(value, this.props.history);
    this.toggle();
  }
  handleProjectLinkSubmit(value){
    this.props.addProjectLink(value, this.props.history);
    this.toggle();
  }
  componentDidMount() {
    const { match: { params }, ongetProjectUUIDAction, onGetProjectMedia, onGetProjectLink, onGetProjectOpenHouseFiles } = this.props;
    if (params && params.projectId) {
      ongetProjectUUIDAction(params.projectId);
      onGetProjectMedia(params.projectId);
      onGetProjectLink(params.projectId);
      onGetProjectOpenHouseFiles(localStorage.getItem("userId"))
    }
  }

  handleUncheckedCheckbox(document){
    
  }
  async handleFileChange(event, setFieldValue) {
    const file = event.currentTarget.files[0];
    if (file) {
      const maxSize = 5 * 1024 * 1024;
      const allowedTypes = ['application/pdf', 'application/msword', 'image/jpeg', 'image/png'];
      const allowedExtensions = ['.pdf', '.doc', '.jpg', '.jpeg', '.png'];
      const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
      if (!allowedTypes.includes(file.type) || !allowedExtensions.includes(fileExtension)) {
        Swal.fire({
          title: 'File type or extension not allowed',
          text: 'Please upload a PDF, DOC, JPG, or PNG file.',
          icon: 'warning',
          confirmButtonText: 'OK',
        });
        //alert('Invalid file type. Please upload a PDF, DOC, JPG, or PNG file.');
        return;
      }
      if (file.size > maxSize) {
        Swal.fire({
          title: 'Size not allowed',
          text: 'Please Upload Maximum 5MB File',
          icon: 'warning',
          confirmButtonText: 'OK',
        });
       
      }
      this.setState({ btnloading: true });
      const sasToken = "sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2025-06-22T02:18:02Z&st=2024-06-21T18:18:02Z&spr=https,http&sig=Srg7JmJ7EfJQWUNadO188IgXNeCFEzSmQQmctuyjGxA%3D";
      const containerName = "images";
      const storageAccountName = "realtyspace";
      const fileName = `${Date.now()}_${file.name}`;
      const blobServiceClient = new BlobServiceClient(
        `https://${storageAccountName}.blob.core.windows.net?${sasToken}`
      );
      const containerClient = blobServiceClient.getContainerClient(containerName);
      const blobClient = containerClient.getBlockBlobClient(fileName);

      try {
        await blobClient.uploadBrowserData(file, {
          blobHTTPHeaders: { blobContentType: file.type }
        });

     
        if (setFieldValue) {
          const fileUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${fileName}`;
          setFieldValue(`projectDocumentLink`, fileUrl);
          setFieldValue(`projectDocumentContent`, fileUrl);
          this.setState({ fileUploaded: true });
        }
      } catch (error) {
        console.error('Error uploading file:', error);

      }
    }
  }
  render() {
    const { projectData, documents, links, opfiles, onGetProjectOpenHouseFiles, onGetProjectMedia, onGetProjectLink, isResponsive } = this.props;
    const { deleteModal, fileUploaded} = this.state;
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <ToastContainer autoClose={2000} />
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteFile}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Campaigns | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0 ">
            <Row>
              <Col sm="2" className="pe-0">
                <ProjectSidebar isResponsive={isResponsive} />
              </Col>
              <Col sm="10" className="ps-0">
                <Row className="project-header">
                  <Col sm="7">
                    <WebPageBreadcrumbs
                      title={this.props.t("Projects")}
                      breadcrumbItem={this.props.t("Open House")}
                    />
                  </Col>
                  <Col sm="4">
                    <h2 className="">
                      {this.props.t(projectData.projectName)}
                    </h2>
                  </Col>
                </Row>
                <WebpagesMenu isResponsive={isResponsive} />
                <Card>
                  <CardBody>
                    <TabContent
                      activeTab={this.state.activeTab}
                      className="p-3 text-muted"
                    >
                      <Row>
                        <Col sm="12">
                        <div className="link-page">
                        <h5>
                        <span><a target="_blank" rel="noreferrer" href={"https://worksheetenquiry.realtyspacehub.com/" + this.props.match.params.projectId}><i className="bx bx-link-external"></i> Preview & share</a></span>  <img src={arrowImg} width="40" className="me-2" /> <strong>Note: You can copy and paste the preview  URL with prospects.</strong>
                      </h5>
                        </div>
                        </Col>
                      </Row>
                         <Row>
                                                <Col sm="2" className="d-flex">
                                                  <Card className="border-full mt-4 w-100">
                                                      <CardHeader><h5 className="font-size-18" style={{fontWeight:'bold'}}><img src={step1}  width="40" className="me-2" /> Purpose</h5></CardHeader>
                                                      <CardBody className="d-flex flex-column">
                                                          <p className="text-dark font-size-16">Accelerate lead capture when a project opens for worksheets</p>
                                                      </CardBody>
                                                  </Card>
                                                </Col>
                                                 <Col sm="6" className="d-flex">
                                                  <Card className="border-full mt-4 w-100">
                                                      <CardHeader><h5 className="font-size-18" style={{fontWeight:'bold'}}><img src={step2}  width="40" className="me-2" /> How it works</h5></CardHeader>
                                                      <CardBody className="d-flex flex-column">
                                                            <ol className="text-dark font-size-16">
                                                                <li>The system auto-generates a worksheet inquiry form.</li>
                                                                <li>When a client fills out the form, they receive an email with a link to their personalized “Submit Worksheet” page.</li>
                                                                <li>The client’s details are added as a lead in the system with the status “Worksheet Sent.”</li>
                                                                <li>When the client completes and submits the worksheet, the information is captured in the system.</li>
                                                            </ol>
                                                      </CardBody>
                                                  </Card>
                                                </Col>
                      
                                                <Col sm="4" className="d-flex">
                                                  <Card className="border-full mt-4 w-100">
                                                      <CardHeader><h5 className="font-size-18" style={{fontWeight:'bold'}}><img src={step3}  width="40" className="me-2" /> How To Use</h5></CardHeader>
                                                      <CardBody className="d-flex flex-column">
                                                  
                                                            <ol className="text-dark font-size-16">
                                                                <li>Copy the worksheet inquiry page link shown here and share it with clients through social media, WhatsApp, or other channels. </li>
                                                                <li>Or, send it via mass email using the “Accepting Worksheets” template available under the Email Campaign tab in the left menu.</li>
                                                            </ol>
                      
                                                            
                                                    
                                                      </CardBody>
                                                  </Card>
                                                </Col>
                                              </Row>
                      
                  
               
                    </TabContent>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

ProjectWorksheetInquiry.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  apiError: PropTypes.any,
  ongetProjectUUIDAction: PropTypes.func,
  match: PropTypes.object,
  projectData: PropTypes.object,
  loading: PropTypes.object,
  documents:PropTypes.array,
  onGetProjectMedia:PropTypes.func,
  addProjectMedia:PropTypes.func,
  addProjectLink:PropTypes.func,
  links:PropTypes.array,
  onGetProjectLink:PropTypes.func,
  opfiles:PropTypes.array,
  onGetProjectOpenHouseFiles:PropTypes.func,
  onDeleteFile:PropTypes.func,
  isResponsive:PropTypes.object
};
const mapStateToProps = ({ Project }) => (
{
  links: Project.links,
  documents: Project.documents,
  projectData: Project.projectData,
  opfiles:Project.opfiles,
  loading: Project.loading,

});
const mapDispatchToProps = dispatch => ({
  ongetProjectUUIDAction: id => dispatch(getProjectUUIDAction(id)),
  addProjectMedia: (data) => dispatch(addProjectMedia(data)),
  onGetProjectMedia:(projectId) => dispatch(getProjectMedia(projectId)),
  addProjectLink: (data) => dispatch(addProjectLink(data)),
  onGetProjectLink:(projectId) => dispatch(getProjectLink(projectId)),
  onGetProjectOpenHouseFiles:(agentId) => dispatch(getProjectOpenHouseFiles(agentId)),
  onDeleteFile:(id) => dispatch(deleteProjectOpenHouseFile(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(ProjectWorksheetInquiry)));
